import { detachEnemy } from '../render/enemy-instances';
import { UIPREF } from '../platform/ui-prefs';
import { armBossDeath } from '../render/boss-field';
import { bossPartAt, damageBossPart } from './boss-parts';
import { rebuildBossRig } from '../entities/boss-rig';
import { addCorpse } from '../render/enemy-field';
import { RULE } from './rules';
import { IMPACT_MUL, addImpact, damageMul, relayImpact, staggered } from './impact';
import { setBoss } from '../entities/enemies';
import { detonate } from './enemy-kinds';
import * as THREE from 'three';
import { boss } from '../entities/enemies';
import { elFx } from '../platform/dom';
import { TAU, rnd } from '../core/math';
import { RNG, rr } from '../core/rng';
import { MW_DROP_CHANCE } from '../data/mech-upgrades';
import { enemies } from '../entities/enemies';
import { SFX } from '../platform/audio';
import { eliteKey, logKilled } from '../platform/storage';
import { elStage } from '../platform/dom';
import { camera, scene } from '../render/scene';
import { onBossKilled } from './stage-flow';
import { losBlocked } from '../world/arena';
import { P } from '../world/player';
import { camPunch } from './camera';
import { CHEST, TIERS, trashCdAt } from './chest';
import { metHit, metKill } from './metrics';
import { MAT_HEAL, MAT_ORB, chests, debris, orbs, rings } from '../world/pools';
/* ============================================================
   特效與傷害
   ============================================================ */
export var STATE = {
  phase: 'idle',    // idle | wave | boss | clear | done
  running: false, over: false, paused: false, reward: false,
  /* 對局結果。`over` 只說「結束了」，分不出勝敗 ——
     M7 加上勝利條件（活到 20 分鐘）之後就需要區分，否則測試與結束畫面
     都只能靠猜。 */
  won: false,
  /** 玩家 9 單位內的雜兵數。護盾要「脫離接觸」才回充（見 sim/player.ts）。 */
  nearP: 0,
  /** 玩家 22 單位內的敵人數。**鏡頭用**：被圍住時自動拉遠（`sim/camera.ts`）。
      與 `nearP` 分開數是因為兩者問的問題不同：nearP 問「有沒有貼身」，
      這一個問「畫面上有多少東西」。 */
  near20: 0,
  stage: 0, t: 0, spawnT: 0, timeScale: 1, shake: 0, seed: 0, runT: 0
};
export var tmpV = new THREE.Vector3();
/** 兩個角度的最短夾角，落在 [−π, π]。

    **兩次取模是必要的，不是防禦性程式碼。** 舊版是
    `((a - b + 3π) % TAU) - π` —— 那個 `+3π` 是在賭「a − b 不會小於 −3π」，
    而 JS 的 `%` 對負數回傳負值（`-1 % 7 === -1`，不是 6）。賭輸的時候
    結果會落在 [−2π, −π]，`Math.abs()` 之後永遠大於任何角度門檻，
    於是所有「在不在這個扇形裡」的判定**永遠回 false**。

    實際踩到的是環繞旋刃（`data/weapons-pool.ts` 的 `w-orbit`）：它的刀刃相位
    `st.a` 是無上限累積的，開局約 3 秒後就跨過 −3π，接觸傷害從此完全停止 ——
    刀刃照轉、特效照放、沒有任何錯誤。使用者 2026-08-05 回報過
    「刀片好像不會造成傷害了」，當時被當成缺少命中特效處理掉了。

    對原本就在 [−π, π] 的輸入，新舊兩式結果完全相同。 */
export function angDiff(a, b) {
  var d = (a - b + Math.PI) % TAU;
  if (d < 0) d += TAU;
  return d - Math.PI;
}
/* 以模擬時間排程的延遲動作，取代 setTimeout。

   牆鐘計時器的回呼會落在不確定的模擬步上（幀率不同、暫停、分頁切走都會偏移），
   同一顆種子因此重現不出同一場。改用模擬時間之後，延遲多久就是延遲多少個 dt。 */
export var pending = [];
export function schedule(delay, fn) { pending.push({ t: delay, fn: fn }); }
export function updateSchedule(dt) {
  for (var i = pending.length - 1; i >= 0; i--) {
    var p = pending[i];
    p.t -= dt;
    if (p.t <= 0) { pending.splice(i, 1); p.fn(); }
  }
}
export function clearSchedule() {
  pending.length = 0;
  /* 回復類的節流狀態跟著清。**不清的話下一場會帶著上一場的 `nextDrop`**
     （可能是 1250 秒），於是整場一個修復包都不掉，而且不會有任何錯誤 ——
     這個 codebase 記過三次「新欄位忘了在 startRun 歸零」。
     掛在這裡是因為 `clearEntities()` 已經是每場開頭必經的入口。 */
  HEALG.nextDrop = 0; HEALG.lsSec = -1; HEALG.lsAcc = 0;
}

export function shake(a) { STATE.shake = Math.min(1.4, STATE.shake + a); }
export function hitstop(t) { STATE.timeScale = Math.min(STATE.timeScale, t); }

export function spawnRing(x, z, color, s0, s1, life, y?) {
  var r = rings.get(); if (!r) return;
  r.m.material.color.setHex(color);
  r.m.position.set(x, y === undefined ? 0.12 : y, z);
  r.m.scale.set(s0, s0, s0); r.life = 0; r.max = life; r.s0 = s0; r.s1 = s1;
  scene.add(r.m);
}
export function spawnDebris(x, y, z, color, n, power, size?) {
  for (var i = 0; i < n; i++) {
    var d = debris.get(); if (!d) return;
    d.m.material.color.setHex(color);
    d.m.position.set(x + rnd(-0.4, 0.4), y + rnd(-0.3, 0.6), z + rnd(-0.4, 0.4));   // det-ok: 開機期：傷害數字的 DOM 池，只在 initDmgPool 執行一次，不在模擬路徑上
    var s = size * rnd(0.5, 1.2); d.s0 = s; d.m.scale.set(s, s, s);   // det-ok: 純視覺：殘骸大小
    d.m.rotation.set(rnd(0, TAU), rnd(0, TAU), rnd(0, TAU));   // det-ok: 純視覺：殘骸初始角度
    var a = rnd(0, TAU);   // det-ok: 純視覺：殘骸飛散方向
    d.v.set(Math.cos(a) * rnd(3, 11) * power, rnd(3, 10) * power, Math.sin(a) * rnd(3, 11) * power);   // det-ok: 純視覺：殘骸初速
    d.av.set(rnd(-9, 9), rnd(-9, 9), rnd(-9, 9));   // det-ok: 純視覺：殘骸自轉
    d.life = 0; d.max = rnd(0.7, 1.3); scene.add(d.m);   // det-ok: 純視覺：殘骸壽命
  }
}
/* 傷害數字用 DOM 而不是 canvas texture，因為字體渲染品質差很多。
   池子在 initDmgPool() 才建立 —— 這是第三個接縫，headless 時整個跳過，
   spawnDmg 取不到元素就直接 return，模擬不受影響。 */
export var dmgPool = [], dmgActive = [];
export function initDmgPool() {
  for (var _i = 0; _i < 34; _i++) {
    var _e = document.createElement('div'); _e.className = 'dmg'; _e.style.display = 'none';   // det-ok: 開機期：傷害數字的 DOM 池，只在 initDmgPool 執行一次
    elFx.appendChild(_e); dmgPool.push(_e);
  }
}
export function popDmg(x, y, z, txt, cls) {
  /* 傷害數字的開關（設定頁）。**只擋純數字** —— `heal`／`blk` 與
     「緊急補給」那類提示是狀態回饋不是噪音，關掉它們玩家會不知道發生了什麼。 */
  if (!UIPREF.dmgNum && !cls) return;
  var el = dmgPool.pop(); if (!el) return;
  el.textContent = txt; el.className = 'dmg ' + (cls || '');
  el.style.display = 'block'; el.style.opacity = '1';
  dmgActive.push({ el: el, p: new THREE.Vector3(x, y, z), life: 0, max: 0.75, vx: rnd(-16, 16) });   // det-ok: 純視覺：傷害數字的橫向漂移
}
export function updateDmg(dt) {
  for (var i = dmgActive.length - 1; i >= 0; i--) {
    var d = dmgActive[i]; d.life += dt;
    if (d.life >= d.max) { d.el.style.display = 'none'; dmgPool.push(d.el); dmgActive.splice(i, 1); continue; }
    d.p.y += dt * 3.2;
    tmpV.copy(d.p).project(camera);
    var w = elStage.clientWidth, h = elStage.clientHeight;
    var sx = (tmpV.x * 0.5 + 0.5) * w + d.vx * d.life, sy = (-tmpV.y * 0.5 + 0.5) * h;
    var k = d.life / d.max;
    d.el.style.transform = 'translate(-50%,-50%) translate(' + sx.toFixed(1) + 'px,' + sy.toFixed(1) + 'px) scale(' + (1.25 - k * 0.45).toFixed(2) + ')';
    d.el.style.opacity = String(1 - k * k);
  }
}

export function nearestEnemy(from, maxDist, preferAngle?, needLos?) {
  var best = null, bestScore = Infinity;
  for (var i = 0; i < enemies.length; i++) {
    var e = enemies[i];
    var dx = e.pos.x - from.x, dz = e.pos.z - from.z, d = Math.hypot(dx, dz);
    if (d > maxDist) continue;
    var score = d;
    if (preferAngle !== undefined) score = d + Math.abs(angDiff(Math.atan2(dx, dz), preferAngle)) * 6;
    if (e.T.boss) score *= 0.7;
    if (score < bestScore) {
      // 反過來也成立：**你飛起來就打得過矮牆**（射線高度＝玩家高度）
      if (needLos && losBlocked(from.x, from.z, e.pos.x, e.pos.z, P.y)) continue;
      bestScore = score; best = e;
    }
  }
  return best;
}

/* src 是傷害來源的武裝代號，決定衝擊效率（見 sim/impact.ts 的 IMPACT_MUL）。
   省略時當作 'prop'（場地與其他來源）。**不要**為了細分傷害歸因改它的值——
   who 是專門給統計用的細粒度標籤（見 .claude/notes/damage-paths.md），
   兩者故意分開：src 動了會連帶改掉衝擊效率的查表結果。 */
export function damageEnemy(e, dmg, crit?, kx?, kz?, src?, hx?, hz?, who?) {
  /* 磁軌校準：靜止 1.2 秒之後全武裝增傷。乘在**傷害的入口**，
     所以池子武裝、機體武裝、進化全部自動吃到，不用逐一接線。 */
  if (RULE.anchorMul > 1 && P.stillT > 1.2) dmg *= RULE.anchorMul;
  /* 空中輸出懲罰（預設 ×0.7）。同樣乘在入口，理由同上一段。
     被動／配件把它買回 1.0 就是「空中戰 build」的入口。 */
  if (P.airMul !== 1) dmg *= P.airMul;
  /* Boss 的無敵窗口：階段轉場（1.2 秒，給玩家看變形）與召喚護盾
     （清完召出來的那批才破）。**照實顯示「免疫」** —— 傷害數字照跳、
     血條不動的話，玩家只會以為遊戲壞了。 */
  if (e.invulnT > 0 || e.shield) {
    e.flash = 0.06; e.dirty = true;
    popDmg(e.pos.x, e.T.y + e.r + 0.9, e.pos.z, e.shield ? '護盾' : '免疫', 'blk');
    return;
  }
  /* 可破壞部位（規格 §5.2）。判定用**命中點相對機體正面的方位角** ——
     主砲是自動瞄準的，所以弱點只能靠走位打得到，不能靠準頭
     （判準與理由寫在 `sim/boss-parts.ts` 檔頭）。
     打中弱點的那一擊本體也吃 1.25 倍 —— 繞過去的走位要有立即的回報，
     不能只有「打壞它之後才有好處」。 */
  if (e.partHp) {
    var wp = bossPartAt(e, hx, hz);
    if (wp >= 0) { damageBossPart(e, wp, dmg); dmg *= 1.25; }
  }
  var stag = staggered(e);
  var real = dmg * damageMul(e);          // 踉蹌期間大幅增傷，這是集中火力的報酬
  e.hp -= real; e.flash = 0.10; e.dirty = true;
  metHit(e, real, who || src || 'prop');   // 傷害歸因與 TTK 的起點（預設關閉）—— who 優先，沒有就退回粗分類的 src
  if (kx || kz) { var kb = e.T.boss ? 0.12 : 1; e.vel.x += kx * kb; e.vel.z += kz * kb; }
  popDmg(e.pos.x, e.T.y + e.r + 0.9, e.pos.z, Math.round(real), stag ? 'crit' : (crit ? 'crit' : ''));
  /* 第三個參數 = 「這一隻值得單獨聽見」。雜兵的命中會被密度層聚合
     （`platform/audio-density.ts`）—— 一秒 33 次的命中音是 2026-08-06
     「音效讓我很難受」的一半病因，而玩家真正在盯的只有這三種目標。 */
  SFX.hit(e.pos.x, e.pos.z, !!(e.T.boss || e.elite || P.lockT === e));

  if (!stag && addImpact(e, dmg * (IMPACT_MUL[src || 'prop'] || 1))) {
    // 剛被打踉蹌：演出要夠明顯，玩家必須立刻知道「窗口開了」
    spawnRing(e.pos.x, e.pos.z, 0xffffff, e.r, e.r * 7, 0.45);
    SFX.alarm(); shake(e.T.boss ? 0.5 : 0.16); hitstop(e.T.boss ? 0.22 : 0.06);
    camPunch(e.T.boss ? 1.0 : 0.35);   // 踉蹌是玩家最想被獎勵的一刻，鏡頭要跟著喘一下
  }
  if (e.hp <= 0) killEnemy(e);
}
/** 修復包的低血加成門檻與倍率（見 `killEnemy` 裡的說明）。
    **這是難度旋鈕**，跟 `data/pacing.ts` 的三張表同一個層級 ——
    改它之前先看那個檔的註解表格（哪個旋鈕會污染哪把尺）。 */
export var HEAL_LOW = 0.40;
export var HEAL_LOW_MUL = 3;

/** 修復包的**掉落冷卻**（秒）與吸血的**每秒上限**（佔結構上限的比例）。

    ---------- 2026-08-06：per-kill 的兩條回復路徑都爆了 ----------

    使用者實玩：「後期擊殺回血太強，完全不會被打死」。報表佐證：
    第 4 區的「耐久」欄從 0:30 到 19:30 全程 125–158（幾乎沒掉過血）。

    兩條路徑都是 per-kill：修復包 `RNG.next() < 0.028`、吸血 `heal(lifesteal)`。
    `killEnemy` 那一段的舊註解自己算過「後期每秒 1.4 個包 ＝ 每秒 +30 HP」，
    而現在的擊殺率比當時更高（同屏 280、DPS 20,000）——
    玩家血量上限只有 140–158，等於**每三秒回滿一次**。

    這正是 lessons 記過的結構性坑：**「每殺一隻 roll 一次」的東西在這個
    遊戲裡都會隨密度爆掉**。銅箱 2026-08-05 已經改成冷卻制（`sim/chest.ts`），
    這兩條是同族的漏網之魚。

    ⚠️ **roll 仍然照抽，只有「掉不掉得出來」被冷卻擋掉** —— 把 `RNG.next()`
    包進條件裡的話，冷卻中與冷卻外會消耗不同數量的亂數，同一顆種子的
    後續路徑就會因為「上次掉包的時間」而整條位移，前後版本的量測比不了。 */
export var HEAL_CD = 6;
export var LIFESTEAL_CAP = 0.05;
/** 修復包的下一次可掉時刻、以及吸血在這一秒已經回了多少。
    **模組層級的可變狀態一定要有重置入口**（`resetFx` 會清）。 */
export var HEALG = { nextDrop: 0, lsSec: 0, lsAcc: 0 };

/** 擊殺引爆的連鎖深度（見 `killEnemy` 裡的說明）。**不是設定值，是護欄。**
    改大之前先想清楚：這個數字直接決定遞迴的層數。 */
var shardDepth = 0;
var SHARD_MAX_DEPTH = 2;
/** 連鎖層的傷害倍率。**這一個是平衡旋鈕不是護欄**（上面那個才是）——
    調它之前跑 `pnpm metrics`，看第 5 區 `p-shard` 的佔比有沒有壓回 40% 以下。 */
var SHARD_CHAIN_FALLOFF = 0.5;

export function killEnemy(e) {
  metKill(e);   // 要在移除之前記，之後 e 會被還回池子
  var T = e.T;
  /* 死亡塌陷（規格 §9 開頭：小怪是「塌下去 + 縮小」0.6 秒）。
     **純視覺**，屍體留在渲染層自己演，模擬層照舊立刻移除這一隻 ——
     留在 `enemies` 裡的話索引與長度都會變，決定性快照跟著變。 */
  addCorpse(e);
  /* 回收協定：擊殺掉修復包。用種子 RNG 不是 Math.random ——
     掉不掉是對局的一部分，用牆鐘亂數會讓同一顆種子跑出不同的一場。 */
  if (RULE.salvage > 0 && RNG.next() < RULE.salvage) dropHeal(e.pos.x, e.pos.z);
  /* 鎖定共鳴：鎖定的目標死掉時，把它累積的衝擊進度轉移給下一個目標。
     沒有這條的話「專心打一隻」的代價是它死掉那一刻進度歸零，
     而那正是衝擊 build 最痛的地方。 */
  if (RULE.relay > 0 && P.lockT === e) relayImpact(e, RULE.relay);
  spawnDebris(e.pos.x, T.y + T.r * 0.6, e.pos.z, T.body, T.boss ? 34 : 7, T.boss ? 1.9 : 1, T.r * 0.55);
  spawnDebris(e.pos.x, T.y + T.r * 0.6, e.pos.z, T.accent, 4, 1.2, T.r * 0.3);
  spawnRing(e.pos.x, e.pos.z, T.accent, T.r * 0.6, T.r * (T.boss ? 9 : 3.6), T.boss ? 1.0 : 0.42);
  SFX.kill(e.pos.x, e.pos.z, !!(T.boss || e.elite || P.lockT === e));
  /* BOSS 的死亡是**一整段編排**（規格 §9 的四拍 + 骨段解體，移植自原型 §12）。
     `armBossDeath` 接管這具 rig 繼續演，模擬層照舊立刻移除這一隻 ——
     跟小怪的塌陷同一條原則：純視覺的東西不該動到 `enemies` 的長度與索引。

     ⚠️ 接管之後那顆 root 就**不能還給池子**了（炸裂會把它拆成自由剛體），
     所以立刻重建一具。成本是一次 `build()`，一場最多五次。 */
  if (T.boss) {
    SFX.boom(); shake(1.3); hitstop(0.2);
    if (T.bossRig && e.rig) { armBossDeath(e); rebuildBossRig(e); }
  }
  else shake(0.09);
  if (!T.boss) {
    /* 經驗跟著**這一隻的實際血量**走，不是牠的基礎值（P5）。
       01 §五：「敵人掉落的經驗值也隨時間縮放，兩條曲線一起調」——
       在此之前這顆旋鈕根本不存在，`xp` 是每個敵種一個固定的 1–5。
       後果：把敵人血量調硬 4 倍，擊殺率就掉 4 倍，經驗也掉 4 倍 ——
       玩家的整條戰力曲線是掛在擊殺率下面的，於是「調難度」實際上是
       「調玩家的成長速度」，兩件事永遠分不開。實測（`pnpm metrics` 五種子）：
       開場血量 ×4.4 之後擊殺數從 5935 掉到 635、存活中位數 7.4 分 → 3.0 分。

       `e.xpVal` 在 `spawnEnemy` 一起算好（跟 `hpMax` 同一行邏輯），
       讓「每點傷害換到的經驗」保持定值 —— 血量表因此變成純粹的手感旋鈕，
       升級節奏改由 `sim/level.ts` 的曲線獨立決定。

       ⚠️ 01 寫的是 `xp_drop ∝ HP^0.5`，這裡用的是 **^1.0**。差別是刻意的：
       0.5 次方會讓兩個系統仍然互相牽動，1.0 才真的正交。 */
    dropOrb(e.pos.x, e.pos.z, e.elite ? e.xpVal * 12 : e.xpVal);
    /* 擊殺掉修復包（基礎 2.8%，血量低於 `HEAL_LOW` 時 ×`HEAL_LOW_MUL`）。

       **為什麼是低血加成而不是直接調高基礎值**（使用者 2026-08-05 要求
       「打掉敵人有低機率掉回血包，可能會降低難度」）：掉落量正比於**擊殺率**，
       而擊殺率一場之內從 1.5/秒 漲到 50/秒 —— 基礎值 2.8% 在後期已經是
       每秒 1.4 個包（每秒 +30 HP）。直接調高等於把危機期整段抹平，
       而最需要它的是第 3–6 分鐘那段「一個失誤就滾雪球」的窗口。
       低血加成是**自限**的：滿血時完全沒有效果。
       同族的既有機制：抽卡的結構保底（`sim/draft.ts`：結構 < 30% 連兩輪沒回復）。

       ⚠️ **roll 一律照抽，只有門檻在變** —— 把 `RNG.next()` 包進條件裡的話，
       低血與滿血兩種狀態會消耗不同數量的亂數，同一顆種子的後續路徑
       就會因為「玩家血量」而整條位移，前後版本的量測比不了。 */
    var hp01 = P.hpMax > 0 ? P.hp / P.hpMax : 1;
    /* ⚠️ **roll 照抽、冷卻另外擋**（2026-08-06）：把冷卻寫進 `if` 的條件裡
       會讓亂數消耗量隨玩家狀態改變，同種子的軌跡就不可比了（同上面那條註解）。
       機率本身不動 —— 前期每秒殺 1.5 隻，2.8% 遠遠碰不到 6 秒的冷卻，
       所以這一手**只削後期**，那正是使用者說「完全不會被打死」的那一段。 */
    /* 冷卻**在低血時要放寬**：低血加成存在的理由就是「快死了要給活路」，
       而第一版的固定 6 秒冷卻把那條保險一起擋掉了 —— 十顆種子全滅
       （存活中位數 15.5 → 4.8 分）。滿血時擋滿、低血時只擋三分之一。 */
    var hcd = hp01 < HEAL_LOW ? HEAL_CD / 3 : HEAL_CD;
    if (RNG.next() < 0.028 * (hp01 < HEAL_LOW ? HEAL_LOW_MUL : 1)
      && STATE.t >= HEALG.nextDrop) {
      dropHeal(e.pos.x, e.pos.z);
      HEALG.nextDrop = STATE.t + hcd;
    }
    /* 小怪的銅箱。照搬 VS 的機率之後，精英箱的期望件數從固定 3 掉到 1.3–1.6，
       這一條是用來補那個缺口的（使用者 2026-08-04：「照搬 VS 讓小怪也有機率掉寶箱」）。
       **2026-08-05 從 per-kill 機率換成冷卻**（理由與量測數字見 `sim/chest.ts`
       的 `CHEST` 註解）：機率乘上擊殺率會隨密度爆掉，冷卻讓節奏與密度脫鉤。
       銅箱**不出進化**，所以它只影響升級速度不影響 build 走向。 */
    if (!e.elite && CHEST.trashCd > 0 && STATE.t >= CHEST.nextTrash) {
      dropChest(e.pos.x, e.pos.z, false, 'bronze');
      /* 冷卻隨時間拉長（`trashCdAt`）—— 前 8 分鐘不動，之後才變長。
         用固定值砍的是整場，而「箱子太多」是後期的問題（見 chest.ts 的註解）。 */
      CHEST.nextTrash = STATE.t + trashCdAt(STATE.t) * rr(0.7, 1.3);
    }
    /* 擊殺引爆。**連鎖深度一定要夾** —— 引爆會擊殺、擊殺又引爆，
       這是一條直接的遞迴。在收割協定（`data/protocols.ts` 的 `x-reap`）
       之前 `shardKill` 恆為 0，所以這條路徑從來沒有被跑過；接上的第一次
       就把三支 bot 診斷打成 `Maximum call stack size exceeded`。
       上限 2 的意思是「死者引爆、被引爆而死的再引爆一次，就到此為止」——
       看得到連鎖，但一次擊殺不會把整個畫面清空。 */
    if (P.s.shardKill > 0 && shardDepth < SHARD_MAX_DEPTH) {
      /* 連鎖層的傷害**要衰減**。第一版是等值連鎖，五種子量下來
         `p-shard` 一個來源就吃掉 59.6% 的總傷害（07 的紅線是 40%）——
         一枝獨秀，拿到它之後其他武裝都不重要了。
         衰減而不是砍掉連鎖：連鎖是「收割」這個機制的全部樂趣，
         砍掉就只剩一個會爆炸的被動。 */
      var sd = P.s.shardKill * (shardDepth > 0 ? SHARD_CHAIN_FALLOFF : 1);
      shardDepth++;
      areaDamage(e.pos.x, e.pos.z, 4.2, sd, 0x9fd8ff, e, 'p-shard');
      shardDepth--;
    }
    /* 吸血同樣要夾**每秒上限**（2026-08-06）。它是 per-kill 的，
       後期每秒殺數十隻＝每秒回好幾百點，而結構上限只有 140–158。
       上限用「佔結構上限的比例」而不是絕對值：血量會隨局外部件與
       應急改裝成長，寫死絕對值的話同一條規則在不同 build 下鬆緊差很多。 */
    if (P.s.lifesteal > 0 && P.alive) {
      var sec = Math.floor(STATE.t);
      if (sec !== HEALG.lsSec) { HEALG.lsSec = sec; HEALG.lsAcc = 0; }
      var cap = P.hpMax * LIFESTEAL_CAP;
      var give = Math.min(P.s.lifesteal, cap - HEALG.lsAcc);
      if (give > 0) { HEALG.lsAcc += give; heal(give); }
    }
  }
  /* 死亡殉爆：會爆的敵人被打死時**一樣會炸**（正解是拉開距離）。
     目前沒有任何型別有 `boom` —— DORN 移植進來之後才會走到這裡。 */
  if (T.boom && !e.detonated) { e.detonated = true; detonate(e); }
  if (e.elite) {
    /* 精英擊破：額外演出，**小隊長**才掉寶箱。這是玩家追著精英打的理由。

       「一隻精英一個寶箱」在 M12 之前是對的（一次只出一隻）。改成成組之後
       那條規則會讓寶箱數翻一倍以上，而寶箱是合成品的唯一來源 ——
       實測 20 分鐘拿到兩個融合品、把該進化的武裝都吃掉了。
       所以掉落跟著**組**走不是跟著隻走：組員給經驗，組長給寶箱。
       `eliteLead` 由 `elites.ts` 的 `spawnEliteSquad` 指定（見那裡的說明）。 */
    var ca = rr(0, TAU);
    /* 2026-08-04 晚第二次調整（使用者拍板）：**箱種整排往下遞補**，
       因為金箱讓給了 Boss 擊破。組員銀 → 銅、首領金 → 銀。
       首領的銀箱現在是**五選三**，價值比原本的「三選一＋金箱拉霸」還高。 */
    /* **組員不掉箱，只給經驗**（2026-08-05，使用者：「箱子還是太多了」）。

       量到的：一場開箱中位數 **100 次**，而精英是成組出現的 ——
       每個組員一個銅箱就是那個數字的主體。`sim/chest.ts` 的冷卻改動只治得到
       小怪掉的那一份，治不到這裡。

       **對合成品的供給沒有影響**：銅箱 `craft: false`（`TIERS`），
       進化與融合只從銀箱（組長）與金箱（Boss）出。減少的是升級速度，
       以及「抽卡池空掉時空箱轉回血 60」那份隱形治療
       （一場約 5,700 HP，`sim/projectiles.ts:252`）—— 後者是實質的難度上調，
       改完要重跑 `pnpm metrics` 看存活。 */
    if (e.eliteLead) {
      /* 精英首領：**銀箱五選三**。
         原本這裡還會 `P.pendingLv++`（額外一次三選一），拉掉了 ——
         五選三本身就是升級版的獎勵，再加一次三選一會讓一隻首領給到
         四次選擇，而 `01-run-pacing.md` 的總升級次數目標是 32–38，
         這一條會把它整個吃掉。獎勵集中在箱子上，「要不要走過去」
         這個既有的設計重點也才保得住。 */
      dropChest(e.pos.x + Math.cos(ca) * 1.4, e.pos.z + Math.sin(ca) * 1.4, false, 'silver');
      /* **額外**再掉一個武裝強化箱的機率（使用者 2026-08-03：「讓精英怪也有
         少量機率掉落武器升級」）。它是 Boss 之外唯一的來源，份量刻意小 ——
         Boss 的四次仍然是主線，這一條只是讓中段不至於乾等五分鐘。

         **是加掉不是換掉**：一般寶箱是進化與融合的唯一來源（見上面那段
         M12 的說明），把它換成強化箱等於偷偷調低了合成品的產出 ——
         那是另一個系統的平衡，不該被這條順手改掉。
         抽在掉落當下而不是撿起來時：玩家要先看得到顏色才決定跑不跑那一趟。 */
      if (RNG.next() < MW_DROP_CHANCE) {
        var ma = ca + 2.4;
        dropChest(e.pos.x + Math.cos(ma) * 3.2, e.pos.z + Math.sin(ma) * 3.2, true);
      }
    }
    SFX.boom(); shake(0.6); hitstop(0.12);
  }
  P.kills += e.elite ? T.score * 10 : T.score;
  /* 圖鑑的第三段解鎖。**打死才給完整資料** —— 使用者訂的規則，
     而它剛好也是對的：一隻你沒打死過的敵人，你對它的了解就是不完整的。 */
  logKilled(e.type);
  /* 精英另外記一份 —— 圖鑑的精英切換是獨立解鎖的。 */
  if (e.elite) logKilled(eliteKey(e.type));
  var wasBoss = T.boss;
  removeEnemy(e);
  if (wasBoss) onBossKilled(e);
}
export function removeEnemy(e) {
  e.alive = false; detachEnemy(e);
  var i = enemies.indexOf(e); if (i >= 0) enemies.splice(i, 1);
  if (boss === e) setBoss(null);
}
export function areaDamage(x, z, radius, dmg, color, skip?, who?) {
  spawnRing(x, z, color, 0.4, radius * 1.1, 0.35);
  for (var i = enemies.length - 1; i >= 0; i--) {
    var e = enemies[i]; if (!e || e === skip) continue;   // damageEnemy 可能連鎖移除多隻
    var dx = e.pos.x - x, dz = e.pos.z - z, d = Math.hypot(dx, dz);
    if (d < radius + e.r) { var k = 1 / Math.max(0.6, d); damageEnemy(e, dmg, false, dx * k * 5, dz * k * 5, undefined, undefined, undefined, who); }
  }
}
/* 寶箱掉落。故意**不進 orbs 池** —— orbs 會被磁力吸過來，
   而寶箱的價值有一半在「你得走過去」。 */
export function dropChest(x, z, mw?, tier?) {
  var c = chests.get(); if (!c) return;
  c.m.position.set(x, 0, z); c.m.rotation.y = rr(0, TAU); c.life = 0;
  c.tier = tier || 'silver';
  /* 武裝強化箱：橘色，跟三種一般寶箱分開。**顏色要在撿之前就看得到** ——
     四種箱子的價值完全不同，長得一樣的話玩家沒辦法決定值不值得跑那一趟。
     銅／銀／金的顏色來自 `sim/chest.ts` 的 TIERS，單一事實來源。 */
  c.mw = !!mw;
  var col = c.mw ? 0xff8a3d : (TIERS[c.tier] || TIERS.silver).col;
  if (c.ring) c.ring.material.color.setHex(col);
  if (c.beam) {
    c.beam.material.color.setHex(col);
    /* 光柱**同時加亮**。實看截圖裡只換色是不夠的：俯視鏡頭下箱子只有幾十像素，
       金與橘在那個尺寸下幾乎分不出來（我拿材質顏色印出來才確認換對了）。
       亮度差是遠距離唯一讀得到的訊號。 */
    /* 金箱的光柱比銀／銅亮：俯視鏡頭下箱子只有幾十像素，換色在那個尺寸
       幾乎分不出來（實看截圖驗過），亮度差才是遠距離讀得到的訊號。 */
    c.beam.material.opacity = c.mw ? 0.32 : (c.tier === 'gold' ? 0.26 : (c.tier === 'silver' ? 0.17 : 0.11));
  }
  scene.add(c.m);
}

export function dropOrb(x, z, xp) {
  var o = orbs.get(); if (!o) return;
  o.m.material = MAT_ORB; o.m.scale.set(0.42, 0.42, 0.42); o.m.position.set(x, 0.7, z);
  o.v.set(rr(-3, 3), rr(4, 7), rr(-3, 3)); o.life = 0; o.xp = xp; o.heal = 0; o.pulling = false;
  scene.add(o.m);
}
export function dropHeal(x, z) {
  var o = orbs.get(); if (!o) return;
  o.m.material = MAT_HEAL; o.m.scale.set(0.7, 0.7, 0.7); o.m.position.set(x, 0.8, z);
  o.v.set(rr(-2, 2), 6, rr(-2, 2)); o.life = 0; o.xp = 0; o.heal = 22; o.pulling = false;
  scene.add(o.m);
}
export function heal(n) { P.hp = Math.min(P.hpMax, P.hp + n); }
